import React from 'react';
import PropTypes from 'prop-types';

import {greyishBlue100} from "assets/jss/main";

ScoreArc.propTypes = {
    color: PropTypes.string.isRequired,
    filledLength: PropTypes.number.isRequired,
    isEmpty: PropTypes.bool
};

const RADIUS = 96;
const STROKE_WIDTH = 16;

export const SIZE = (RADIUS + STROKE_WIDTH / 2) * 2;
export const CENTER = SIZE / 2;
export const ARC_LENGTH = Math.PI * RADIUS;

const ARC_PATH = `M ${STROKE_WIDTH / 2} ${CENTER} A ${RADIUS} ${RADIUS} 0 0 1 ${SIZE - STROKE_WIDTH / 2} ${CENTER}`;

function ScoreArc({color, filledLength, isEmpty}) {
    return (
        <div style={{
            position: 'relative',
            width: `${SIZE}px`,
            height: `${CENTER + 16}px`,
            // purely decorative — being a positioned element, this box (and its
            // absolutely-positioned svg) sits above the overlapping title/tooltip
            // row rendered below it and was eating its hover events
            pointerEvents: 'none'
        }}>
            <svg
                width={SIZE}
                height={CENTER}
                viewBox={`0 0 ${SIZE} ${CENTER}`}
                style={{
                    position: 'absolute',
                    top: 0,
                    left: 0
                }}
            >
                <path
                    d={ARC_PATH}
                    fill='none'
                    stroke={greyishBlue100}
                    strokeWidth={STROKE_WIDTH}
                    strokeLinecap='round'
                />
                <path
                    d={ARC_PATH}
                    fill='none'
                    stroke={color}
                    strokeWidth={STROKE_WIDTH}
                    strokeLinecap={isEmpty ? 'round' : 'butt'}
                    strokeDasharray={`${filledLength} ${ARC_LENGTH}`}
                />
            </svg>
        </div>
    );
}

export default ScoreArc;
